import React from "react";

const ContinueButton = ({ buttonText = "Continue", loading, onClick, className = "", disabled }) => {

  return (
    <button
      className={`${className || "continueButton" } ${loading ? "continueButtonLoading" : ""}`}
      onClick={onClick}
      disabled={loading || disabled}
      type="button"
    >
      {buttonText}
    </button>
  );
};

export default ContinueButton;